import { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { Eye } from "lucide-react";

interface DocsComponentDemoProps {
  children: ReactNode;
  caption?: string;
  className?: string;
  fullWidth?: boolean;
}

export function DocsComponentDemo({ 
  children, 
  caption,
  className,
  fullWidth = false
}: DocsComponentDemoProps) {
  return (
    <div className={cn("my-6", className)}>
      <div 
        className={cn(
          "relative rounded-xl border border-border bg-muted/30 p-4 overflow-hidden",
          "shadow-sm",
          fullWidth ? "w-full" : "max-w-2xl"
        )}
      >
        {/* Preview label */}
        <div className="absolute top-2 right-2 z-10">
          <div className="flex items-center gap-1 px-2 py-0.5 rounded-full bg-primary/10 text-primary text-xs font-medium">
            <Eye className="h-3 w-3" />
            <span>Preview</span>
          </div>
        </div>
        
        {/* Demo content wrapper - prevents accidental clicks */}
        <div className="pointer-events-auto [&_button]:cursor-default [&_a]:cursor-default">
          {children}
        </div>
      </div>
      
      {caption && (
        <p className="mt-2 text-xs text-muted-foreground text-center italic">
          {caption}
        </p>
      )}
    </div>
  );
}
